import { IPatientResponse } from '../domain/patient.entities';
import {IPatientGateway} from '../domain/patient.gateway';

export class FindRneUseCase {
  constructor(private findGate: IPatientGateway) {}
  async execute(rne: string): Promise<IPatientResponse | undefined> {
    return await this.findGate.searchByRne(rne);
  }
}
